import Button from 'react-bootstrap/Button';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Stack from 'react-bootstrap/Stack';
import Container from 'react-bootstrap/Container';

function Workout() {
  return (
    <div>
      <h2>Exercise List</h2>
      <p>Create a new plan by adding an exercise to the workout plan </p>
      <Form>
        <Button type="submit" className="mb-3" >Create New Workout</Button> 
        <FloatingLabel controlId="TargetSets" className="mb-3" label="Name of Exercise">
          <Form.Control type="text" placeholder="Sets" />
        </FloatingLabel>

        <Container>
          <Row>
            <Col>
            <FloatingLabel controlId="floatingSelect" className="mb-3" label="Exercise Type">
                <Form.Select aria-label="Floating label select example">
                  <option>Select an exercise</option>
                  <option value="1">Dumbbell Bench Press</option>
                  <option value="2">Romanian Deadlift</option>
                  <option value="3">Split Squats</option>
                  <option value="4">Military Shoulder Press</option>
                </Form.Select>
              </FloatingLabel>
      
              <FloatingLabel controlId="TargetSets" className="mb-3" label="Target Number of Sets">
                <Form.Control type="number" placeholder="Sets" />
              </FloatingLabel>
      
              <FloatingLabel controlId="TargetReps" className="mb-3" label="Target Number of Reps Per Set">
                <Form.Control type="number" placeholder="Reps" />
              </FloatingLabel>
      
              <FloatingLabel controlId="TargetReps" className="mb-3" label="Target Weight (kg)">
                <Form.Control type="number" placeholder="Weight" />
              </FloatingLabel>
      
              <FloatingLabel controlId="TargetReps" className="mb-3" label="Target RPE (Rate of Perceived Exertion)">
                <Form.Control type="number" placeholder="RPE" />
              </FloatingLabel>
      
              <Button type="submit" className="mb-3" >Add Exercise</Button>
  
            </Col>
          </Row>
        </Container>


      </Form>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">4 Sets of Dumbbell Bench Press</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">3 Sets of Split Squats</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Stack gap={3}>
                  <div className="p-2">
                    Set 1:
                    <Form>
                      <Row>
                        <Col>
                          <Form.Control placeholder="Reps" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="Weight (kg)" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="RPE" />
                        </Col>
                        <Col>
                          <Button type="submit">Add Set</Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div className="p-2">
                    Set 2:
                    <Form>
                      <Row>
                        <Col>
                          <Form.Control placeholder="Reps" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="Weight (kg)" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="RPE" />
                        </Col>
                        <Col>
                          <Button type="submit">Add Set</Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div className="p-2">
                    Set 3:
                    <Form>
                      <Row>
                        <Col>
                          <Form.Control placeholder="Reps" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="Weight (kg)" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="RPE" />
                        </Col>
                        <Col>
                          <Button type="submit">Add Set</Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div className="p-2">
                    Set 4:
                    <Form>
                      <Row>
                        <Col>
                          <Form.Control placeholder="Reps" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="Weight (kg)" />
                        </Col>
                        <Col>
                          <Form.Control placeholder="RPE" />
                        </Col>
                        <Col>
                          <Button type="submit">Add Set</Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Stack>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                Second tab content
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>

  );
}

export default Workout;